import { SplitPolyByBBox } from "./index232.js";
import { Vector3toV3 } from "@project-rouge/rg-three";
function recursiveSubdivisionFromData(divisionData, ratios, newDivisionData) {
  const poly = newDivisionData ? newDivisionData.polygon : divisionData.polygon.slice();
  newDivisionData = newDivisionData ?? { polygon: poly, children: [] };
  if (divisionData.children.length > 0 && divisionData.splitDirection !== void 0) {
    const polys = SplitPolyByBBox(poly, ratios[0], divisionData.splitDirection).map((p) => p.map(Vector3toV3));
    newDivisionData.ratio = ratios[0];
    newDivisionData.splitDirection = divisionData.splitDirection;
    ratios.shift();
    for (let i = 0; i < polys.length; i++) {
      newDivisionData.children.push({ polygon: polys[i], children: [] });
      const d = divisionData.children[i];
      if (!d)
        continue;
      recursiveSubdivisionFromData(d, ratios, newDivisionData.children[i]);
    }
  }
  return getLeafPolygons(newDivisionData).map((p) => p.map(Vector3toV3));
}
function getLeafPolygons(divisionData) {
  const polygons = [];
  if (divisionData.children.length === 0)
    polygons.push(divisionData.polygon);
  else
    for (const d of divisionData.children)
      polygons.push(...getLeafPolygons(d));
  return polygons;
}
export {
  recursiveSubdivisionFromData
};
//# sourceMappingURL=index229.js.map
